import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useScrollableStore = defineStore('scrollable', () => {
    const scrollLockCount = ref(0);

    watch(scrollLockCount, () => {
        if (scrollLockCount.value > 0) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.removeProperty('overflow');
        }
    });

    function setIsScrollable(scrollable: boolean) {
        if (scrollable) {
            const count = Math.max(scrollLockCount.value - 1, 0);
            scrollLockCount.value = count;
        } else {
            scrollLockCount.value += 1;
        }
    }

    return {
        setIsScrollable,
    };
});
